const toDisplayName = (value) => {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized || null;
};

const looksLikeEmailAddress = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/u.test(value);

export const resolvePreferredMessengerDisplayName = (...candidates) => {
  const names = candidates.map(toDisplayName).filter(Boolean);
  return names.find((name) => !looksLikeEmailAddress(name)) || names[0] || null;
};

export const isSelfConversation = (conversation) =>
  conversation?.kind === 'direct' && conversation?.self_conversation === true;

// A self target is an account projection, not a connection or an extra group member.
export const withSelfContact = ({ contacts = [], user = null, userId = user?.id, t }) => {
  if (userId == null || !user) return contacts;
  const id = String(userId);
  const name =
    resolvePreferredMessengerDisplayName(user.full_name, user.name, user.slug) ||
    t('messenger_v2.common.you', 'You');
  const avatar = user.avatar_url ?? user.avatar ?? user.display_picture ?? null;
  return [
    {
      id,
      slug: user.slug ?? null,
      name: t('messenger_v2.self.name', '{name} (You)', { name }),
      avatar_url: avatar,
      avatar,
      isSelf: true,
      relationName: t('messenger_v2.self.subtitle', 'Message yourself'),
    },
    ...contacts.filter((contact) => String(contact.id) !== id),
  ];
};
